import Layout from '@/layout'
// import routerView from '@/layout/routerView.vue'
const processManageRouter = {
  path: '/processManage',
  component: Layout,
  redirect: '/processManage/list',
  name: 'processManage',
  permissionCode: '40709',
  meta: {
    title: '流程管理',
    icon: 'nav-flow'
  },
  children: [
    {
      path: 'list',
      component: () => import('@/views/processManage/page/list.vue'),
      name: 'processList',
      permissionCode: '51134',
      meta: { title: '流程列表' }
    },
    {
      path: 'monitoring',
      component: () => import('@/views/processManage/page/monitoring.vue'),
      name: 'processMonitoring',
      permissionCode: '98582',
      meta: { title: '流程监控' }
    },
    {
      path: 'add',
      component: () => import('@/views/processManage/page/add.vue'),
      name: 'processAdd',
      hidden: true,
      meta: { title: '新建流程', activeMenu: '/processManage/list' }
    },
    {
      path: 'edit',
      component: () => import('@/views/processManage/page/add.vue'),
      name: 'processEdit',
      hidden: true,
      meta: { title: '编辑流程', activeMenu: '/processManage/list' }
    }
  ]
}

// 专业版路由展示
export const processMajorManageRouter = {
  path: '/processManage',
  component: Layout,
  redirect: '/processManage/list',
  name: 'processManage',
  meta: {
    title: '流程管理',
    icon: 'nav-flow'
  },
  children: [
    {
      path: 'monitoring',
      component: () => import('@/views/processManage/page/monitoring.vue'),
      name: 'processMonitoring',
      meta: { title: '流程监控' }
    }
  ]
}
export default processManageRouter
